import React from 'react';

const WelcomeEmail = () => {
  return (
    <html>
      <head>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <title>Welcome to RemoteViz</title>
      </head>
      <body style={{
        margin: '0',
        padding: '0',
        backgroundColor: 'hsl(210, 40%, 96.1%)', // --muted
        fontFamily: 'canada-type-gibson, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }}>
        <table style={{
          width: '100%',
          maxWidth: '600px',
          margin: '0 auto',
          backgroundColor: 'hsl(0, 0%, 100%)', // --background
          borderRadius: '8px',
          overflow: 'hidden',
          boxShadow: '0 4px 6px rgba(95, 67, 108, 0.1)' // Primary color with transparency
        }}>
          {/* Header */}
          <tr>
            <td style={{
              backgroundColor: 'hsl(285, 27%, 45%)', // --primary
              padding: '40px 30px',
              textAlign: 'center'
            }}>
              <div style={{ marginBottom: '20px' }}>
                <svg width="48" height="48" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ margin: '0 auto' }}>
                  <circle cx="16" cy="16" r="14.5" stroke="hsl(0, 0%, 100%)" strokeWidth="3"/>
                  <mask id="path-2-inside-1_306_4050" fill="white">
                    <path fillRule="evenodd" clipRule="evenodd" d="M7 16.195C8.79648 13.0894 12.1542 11 16 11C19.8458 11 23.2035 13.0894 25 16.195C23.2035 19.3006 19.8458 21.39 16 21.39C12.1542 21.39 8.79648 19.3006 7 16.195Z"/>
                  </mask>
                  <path d="M7 16.195L5.26879 15.1935L4.68948 16.195L5.26879 17.1965L7 16.195ZM25 16.195L26.7312 17.1965L27.3105 16.195L26.7312 15.1936L25 16.195ZM7 16.195L8.73121 17.1965C10.1849 14.6835 12.897 13 16 13V11V9C11.4114 9 7.40806 11.4954 5.26879 15.1935L7 16.195ZM16 11V13C19.103 13 21.8151 14.6835 23.2688 17.1965L25 16.195L26.7312 15.1936C24.5919 11.4954 20.5886 9 16 9V11ZM25 16.195L23.2688 15.1936C21.8151 17.7065 19.103 19.39 16 19.39V21.39V23.39C20.5886 23.39 24.5919 20.8946 26.7312 17.1965L25 16.195ZM16 21.39V19.39C12.897 19.39 10.1849 17.7065 8.73121 15.1935L7 16.195L5.26879 17.1965C7.40806 20.8946 11.4114 23.39 16 23.39V21.39Z" fill="hsl(0, 0%, 100%)" mask="url(#path-2-inside-1_306_4050)"/>
                  <circle cx="16" cy="16.1953" r="3" stroke="hsl(0, 0%, 100%)" strokeWidth="2"/>
                  <path d="M28.124 23H3.87598L16 2L28.124 23Z" stroke="hsl(0, 0%, 100%)" strokeWidth="2"/>
                </svg>
              </div>
              <h1 style={{
                margin: '0',
                color: 'hsl(0, 0%, 100%)', // --primary-foreground
                fontSize: '28px',
                fontWeight: '600',
                letterSpacing: '-0.5px',
                fontFamily: 'canada-type-gibson, sans-serif'
              }}>
                Welcome to RemoteViz
              </h1>
              <p style={{
                margin: '10px 0 0 0',
                color: 'hsl(0, 0%, 100%)',
                opacity: '0.9',
                fontSize: '16px',
                fontWeight: '400'
              }}>
                Your journey into remote viewing begins now
              </p>
            </td>
          </tr>
          
          {/* Main Content */}
          <tr>
            <td style={{ padding: '40px 30px' }}>
              <h2 style={{
                margin: '0 0 20px 0',
                color: 'hsl(240, 5.3%, 26.1%)', // --foreground
                fontSize: '24px',
                fontWeight: '600'
              }}>
                Thank you for joining RemoteViz!
              </h2>
              
              <p style={{
                margin: '0 0 20px 0',
                color: 'hsl(240, 5.3%, 26.1%)', // --foreground
                fontSize: '16px',
                lineHeight: '1.6'
              }}>
                We're excited to have you as part of our community of remote viewing practitioners. RemoteViz is designed to help you develop and refine your remote viewing abilities through AI-assisted practice sessions.
              </p>
              
              <h3 style={{
                margin: '30px 0 15px 0',
                color: 'hsl(240, 5.3%, 26.1%)', // --foreground
                fontSize: '20px',
                fontWeight: '600'
              }}>
                Getting Started
              </h3>
              
              <ul style={{
                margin: '0 0 20px 0',
                paddingLeft: '20px',
                color: 'hsl(240, 5.3%, 26.1%)', // --foreground
                fontSize: '16px',
                lineHeight: '1.6'
              }}>
                <li style={{ marginBottom: '8px' }}>
                  Start with your first practice session - you'll receive a random target to view
                </li>
                <li style={{ marginBottom: '8px' }}>
                  Record your impressions and observations in the chat interface
                </li>
                <li style={{ marginBottom: '8px' }}>
                  Reveal the target when you're ready to see how you did
                </li>
                <li style={{ marginBottom: '8px' }}>
                  Review AI feedback to understand your progress and areas for improvement
                </li>
              </ul>
              
              <div style={{
                backgroundColor: 'hsl(210, 40%, 96.1%)', // --muted
                border: '1px solid hsl(214.3, 31.8%, 91.4%)', // --border
                borderRadius: '6px',
                padding: '20px',
                margin: '25px 0'
              }}>
                <h4 style={{
                  margin: '0 0 10px 0',
                  color: 'hsl(285, 27%, 45%)', // --primary
                  fontSize: '18px',
                  fontWeight: '600'
                }}>
                  💡 Pro Tip
                </h4>
                <p style={{
                  margin: '0',
                  color: 'hsl(240, 5.3%, 26.1%)', // --muted-foreground
                  fontSize: '14px',
                  lineHeight: '1.5'
                }}>
                  Don't overthink your first impressions. Remote viewing often works best when you trust your initial thoughts and feelings about a target.
                </p>
              </div>
              
              <div style={{ textAlign: 'center', margin: '30px 0' }}>
                <a href="#" style={{
                  display: 'inline-block',
                  backgroundColor: 'hsl(285, 27%, 45%)', // --primary
                  color: 'hsl(0, 0%, 100%)', // --primary-foreground
                  textDecoration: 'none',
                  padding: '12px 24px',
                  borderRadius: '6px',
                  fontSize: '16px',
                  fontWeight: '600',
                  transition: 'background-color 0.2s'
                }}>
                  Start Your First Session
                </a>
              </div>
              
              <p style={{
                margin: '30px 0 0 0',
                color: 'hsl(240, 5.3%, 26.1%)', // --muted-foreground
                fontSize: '14px',
                lineHeight: '1.5'
              }}>
                If you have any questions or need support, feel free to check out our FAQ section or contact our support team. We're here to help you succeed in your remote viewing journey.
              </p>
            </td>
          </tr>
          
          {/* Footer */}
          <tr>
            <td style={{
              backgroundColor: 'hsl(210, 40%, 96.1%)', // --muted
              padding: '30px',
              textAlign: 'center',
              borderTop: '1px solid hsl(214.3, 31.8%, 91.4%)' // --border
            }}>
              <p style={{
                margin: '0 0 10px 0',
                color: 'hsl(240, 5.3%, 26.1%)', // --muted-foreground
                fontSize: '14px'
              }}>
                © 2024 RemoteViz. All rights reserved.
              </p>
              <p style={{
                margin: '0',
                color: 'hsl(240, 5.3%, 45%)', // --timestamp-foreground
                fontSize: '12px'
              }}>
                You received this email because you signed up for RemoteViz.
              </p>
            </td>
          </tr>
        </table>
      </body>
    </html>
  );
};

export default WelcomeEmail;